import { useSetAtom } from "jotai";
import { Icon } from "@common/index";
import {
    isFilterSheetOpenAtom,
    isSortSheetOpenAtom,
} from "./store/sortFilterAtoms";

// Mobile-only sticky bar at the bottom (sits above the mobile tab bar). The
// buttons open the SortSheet / FilterSheet via the shared atoms. Shared by the
// search results page and the category page (#401 B4).
export const SortFilterBar = () => {
    const openSort = useSetAtom(isSortSheetOpenAtom);
    const openFilter = useSetAtom(isFilterSheetOpenAtom);
    return (
        <div
            data-testid="sort-filter-bar"
            className="md:hidden fixed bottom-14 inset-x-0 z-30 bg-base-100 border-t border-base-200 shadow-[0_-1px_4px_rgba(0,0,0,0.08)]"
        >
            <div className="grid grid-cols-2 h-12">
                <button
                    type="button"
                    onClick={() => openSort(true)}
                    className="flex items-center justify-center gap-2 text-neutral font-bold"
                >
                    <Icon name="swap_vert" className="text-xl" />
                    Sort
                </button>
                <button
                    type="button"
                    onClick={() => openFilter(true)}
                    className="flex items-center justify-center gap-2 text-neutral font-bold border-l border-base-200"
                >
                    <Icon name="tune" className="text-xl" />
                    Filter
                </button>
            </div>
        </div>
    );
};
